<template>
  <div class="contenedor">
      <header class="header" id="header" >

       
            <a href="http://espoch.edu.ec/" class="header__logo"> 
              <img   class="logo__imagen"  src="http://cimogsys.espoch.edu.ec/geoportal_files/LOGOS/ESPOCH.png" alt="">
             </a>

       
        
        <div class="header__titulo">
     GEOPORTAL DEL SISTEMA DE GESTIÓN DE INFORMACIÓN ALPA
        </div>

      </header>
      <hr class="separador_amplio">
  </div>
</template>


<script>
import store from '../store'

  export default {
      name: "cabecera",
      props: ['post'],
      
      data: function(){
          return {
              //playmode: 'with the ball'
              value:false
          }
      },
      methods:{
        portadaState () {
          store.commit('ACTIVEPORTADA')
        },
      },
      components: {
      },
      computed: {
      menuActive () {
        return store.state.menuActive
      }, 
      
    },
  }
</script>


<style lang="scss" scoped src="../sass/cabecera.scss"></style>




// WEBPACK FOOTER //
// src/components/cabecera.vue